import React, { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

export interface Props extends ReactDatePickerProps {
  classNames?: string;
}

const DatePicker = (ReactDatePicker as unknown as { default: typeof ReactDatePicker }).default ?? ReactDatePicker;

const AgePickerInput = forwardRef<
  HTMLButtonElement,
  DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement> & { placeholder?: string },
    HTMLButtonElement
  >
>(({ placeholder, value, ...rest }, ref) => <button ref={ref} type='button' {...rest}>{value || placeholder}</button>);

AgePickerInput.displayName = 'AgePickerInput';

const agePickerClasses = 'text-left w-[110px] m-1 p-2 h-10 border-[1px] border-gray-400 border-solid outline-none rounded-md focus:border-sapphire focus:ring-0 focus:ring-offset-0 focus:outline-none';

export const AgePicker = (props: Props): JSX.Element => {
  const { classNames, ...rest } = props;

  return (
    <DatePicker
      {...rest}
      className={`${agePickerClasses}${classNames ? ` ${classNames}` : ''}`}
      customInput={<AgePickerInput />}
      placeholderText='MM/YYYY'
      popperClassName='z-50'
      dateFormat='MM/yyyy'
      showMonthYearPicker
    />
  );
};
